import { StandardEvents } from '@shopify/events';

class MulroomSourceBox extends HTMLElement {
  connectedCallback() {
    this.scope = this.closest('.shopify-section, dialog');
    this.scope?.addEventListener(StandardEvents.productSelect, this.onProductSelect);
  }

  disconnectedCallback() {
    this.scope?.removeEventListener(StandardEvents.productSelect, this.onProductSelect);
    this.generation = (this.generation || 0) + 1;
  }

  onProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card') || !event.promise) return;
    const generation = this.generation = (this.generation || 0) + 1;
    event.promise.then(({ detail }) => {
      if (!this.isConnected || generation !== this.generation || !detail?.html) return;
      if (!detail.newProduct && detail.productId && String(detail.productId) !== this.dataset.productId) return;
      const next = detail.html.querySelector(`mulroom-source-box[data-block-id="${CSS.escape(this.dataset.blockId)}"]`);
      if (next) this.replaceWith(next.cloneNode(true));
    }).catch(() => {});
  };
}

if (!customElements.get('mulroom-source-box')) customElements.define('mulroom-source-box', MulroomSourceBox);
